module.exports = __webpack_public_path__ + "assets/b3945c646dba2c8fd24e400413d5089d.svg";